import { createContext, useEffect, useState } from "react";
import SchoolStorage from "../utils/localStorage";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({}); // { email, id, role, firstName, lastName, accessToken }
  const [school, setSchool] = useState({}); // { id, name ,logo }
  const [schools, setSchools] = useState([]); // [{ id1, name1 }, { id2, name2 }, ]

  useEffect(() => {
    const setCurrentSchool = () => {
        const {schoolId, schoolName , schoolLogo} = SchoolStorage.getSchool();
        if (schoolId && schoolName) {
          setSchool({ id: schoolId, name: schoolName, logo: schoolLogo });
        }
    };

    setCurrentSchool();
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, school, setSchool, schools, setSchools }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
